import React from "react";

export const CardCert = (props) => {
  const values = props.item;

  return (
    <div
      className="card card-danger card-outline"
      style={{ cursor: "pointer" }}
    >
      <div className="card-body" >
        <h6 className="font-weight-bold mb-4">{props.titulo}</h6>
        {values.map((r, index) => (
          <div key={index}>
            <div className="row">
              {r.name && (
                <div className="col-12 col-md-8">
                  <span className="font-weight-bold">CONTRIBUYENTE</span>
                  <p>{r.name}</p>
                </div>
              )}
              {r.nit && (
                <div className="col-12 col-md-4">
                  <span className="font-weight-bold">NIT</span>
                  <p>{r.nit}</p>
                </div>
              )}
              {r?.city && (
                <div className="col-12 col-md-5">
                  <span className="font-weight-bold">CIUDAD</span>
                  <p>{r.city || r.nom_ciudad}</p>
                </div>
              )}
              <div className="col-12 col-md-5">
                <span className="font-weight-bold">PERIODO</span>
                <p className="text-uppercase">{r.vigencia || r.periodo}</p>
              </div>
              <div className="col-12 col-md-1">
                <button 
                  type="button" 
                  className="btn btn-danger font-weight-bold rounded-sm border-0 float-right btn-lg"
                  onClick={() => {
                    props.getCertificado(values);
                  }}
                >
                  <i className="fa fa-download"></i>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
